import { render, staticRenderFns } from "./WallProfileSection.vue?vue&type=template&id=ac61ddf0&scoped=true"
import script from "./WallProfileSection.vue?vue&type=script&lang=js"
export * from "./WallProfileSection.vue?vue&type=script&lang=js"
import style0 from "./WallProfileSection.vue?vue&type=style&index=0&id=ac61ddf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac61ddf0",
  null
  
)

export default component.exports